import React from 'react';
import { Popover } from 'antd';
import { ButtonGroup } from 'react-rainbow-components';
import { SizeButton, SizeContainer } from '../../../SidebarMenu/styles';
import { fontSizes } from '../../TextBlockToolbar';

export const FontSizeSelector = ({ fontSize, onSizeChange, inputRef, handleKeypress, handleKeyDown, handlePaste }) => {
  return (
    <span>
      <ButtonGroup className='fontSize-button'>
        <SizeButton className='fontSize-button'
          comboBox={1}
          isMinus={1}
          onClick={() => {
            if (!isNaN(fontSize)) {
              onSizeChange(fontSize - 1);
            }
          }}
          radiusLeft={true}
          icon="minus"
        />
        <Popover
          content={
            <SizeContainer>
              <ul>
                {fontSizes.map(data => (
                  <li
                    key={data}
                    onClick={e => {
                      onSizeChange(parseInt(data?.replaceAll('px', '')) );
                    }}
                  >
                    {data}
                  </li>
                ))}
              </ul>
            </SizeContainer>
          }
          title={null}
          trigger="click"
        >
          <div
            ref={inputRef}
            contentEditable={true}
            suppressContentEditableWarning={true}
            className="size-ref ql-size"
            style={{
              width: '50px',
              color: '#000',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#cdcdcd',
            }}
            onKeyPress={handleKeypress}
            onBlur={e => {
              const value = parseFloat(inputRef.current.innerHTML.trim());
              if (value !== fontSize && !isNaN(value) && value >= 1 && value <= 400) {
                onSizeChange(value);
              }
            }}
            onKeyDown={handleKeyDown}
            onPaste={handlePaste}
          >
            {!isNaN(fontSize) && fontSize ? fontSize : ' '}
          </div>
        </Popover>
        <SizeButton className='fontSize-button'
          comboBox={1}
          isMinus={1}
          onClick={() => {
            if (!isNaN(fontSize)) {
              onSizeChange(fontSize + 1);
            }
          }}
          radiusLeft={false}
          icon="plus"
        />
      </ButtonGroup>
    </span>
  );
};


